import { Alert, Group, Stack, Text } from '@mantine/core';
import { IconGift } from '@tabler/icons-react';
import { useTranslation } from '../../context/TranslationContext';

export default function CartFreeOffersNotice({
  freeItems,
  title,
  variant = 'light',
  color = 'green',
}) {
  const { t } = useTranslation();

  if (!Array.isArray(freeItems) || freeItems.length === 0) return null;

  const rows = freeItems
    .filter((fi) => fi && fi.reasonKey && fi.reasonParams && fi.reasonParams.item)
    .map((fi) => ({ ...fi, quantity: Number(fi.quantity) || 0 }));

  if (rows.length === 0) return null;

  return (
    <Alert
      color={color}
      variant={variant}
      radius="lg"
      withCloseButton={false}
      role="status"
      aria-live="polite"
      icon={<IconGift size={20} aria-hidden="true" />}
      title={title ?? t('cartFreeItemsBannerTitle', 'Free items with your order')}
      mb="md"
    >
      <Stack gap={6}>
        {rows.map((fi) => {
          const caption = t(fi.reasonKey, '', fi.reasonParams || {});
          return (
            <Group
              key={`${fi.reasonKey}-${fi.variant_id || ''}`}
              gap="xs"
              wrap="nowrap"
              align="flex-start"
            >
              <Text size="sm" fw={600} component="span">
                {caption}
              </Text>
            </Group>
          );
        })}
        <Text size="xs" c="dimmed" mt={4}>
          {t('cartFreeItemsBannerNote', 'Will be added to your order at checkout — nothing to do.')}
        </Text>
      </Stack>
    </Alert>
  );
}
